/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import { PackagingFragmentFragmentDoc } from './packagingFragment.generated';
import { CompanyFragmentFragmentDoc } from './companyFragment.generated';
import { CompanyServicesFragmentFragmentDoc } from './companyServicesFragment.generated';
import { SocialTagsFragmentFragmentDoc } from './socialTagsFragment.generated';
import { AdditionalCompanyInfoFragmentFragmentDoc } from './additionalCompanyInfoFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Availability_Status_Enum =
  | 'AVAILABLE'
  | 'UNAVAILABLE';

export type Base_Unit_Type_Enum =
  | 'BAG'
  | 'BAG_IN_BOX'
  | 'BOTTLE'
  | 'BOX'
  | 'BOX_SET'
  | 'BULK'
  | 'CAN'
  | 'CARTON'
  | 'CUP'
  | 'FLASK'
  | 'JAR'
  | 'KEG'
  /**   */
  | 'NET'
  | 'PACK'
  | 'PIECE'
  | 'SACHET'
  | 'SLICE'
  | 'SPRAY'
  | 'TIN'
  | 'TRAY'
  /**   */
  | 'TUB'
  | 'TUBE';

export type Billing_Type_Enum =
  /** billed per unit */
  | 'FIXED'
  /** billed per measured weight */
  | 'WEIGHT_DEPENDENT';

export type Brand_Enum =
  /** G20 */
  | 'G20'
  /** Auchan Hyper */
  | 'auchan_hyper'
  /** Auchan MyAuchan */
  | 'auchan_myauchan'
  /** Auchan Super */
  | 'auchan_super'
  /** Biocoop */
  | 'biocoop'
  /** Carrefour City */
  | 'carrefour_city'
  /** Carrefour Contact */
  | 'carrefour_contact'
  /** Carrefour Express */
  | 'carrefour_express'
  /** Carrefour Hyper */
  | 'carrefour_hyper'
  /** Carrefour Market */
  | 'carrefour_market'
  /** Coccimarket */
  | 'coccimarket'
  /** Coccimarket City */
  | 'coccimarket_city'
  /** Coccimarket Easy */
  | 'coccimarket_easy'
  /** Cora */
  | 'cora'
  /** Diago */
  | 'diago'
  /** E.Leclerc */
  | 'e_leclerc'
  /** E.Leclerc Express */
  | 'e_leclerc_express'
  /** Franprix */
  | 'franprix'
  /** Hyper U */
  | 'hyper_u'
  /** Intermarché Contact */
  | 'intermarche_contact'
  /** Intermarché Express */
  | 'intermarche_express'
  /** Intermarché Hyper */
  | 'intermarche_hyper'
  /** Intermarché Super */
  | 'intermarche_super'
  /** Monop’ */
  | 'monop'
  /** Monoprix */
  | 'monoprix'
  /** Netto */
  | 'netto'
  /** Sitis Market */
  | 'sitis_market'
  /** Spar */
  | 'spar'
  /** Super U */
  | 'super_u'
  /** U Express */
  | 'u_express'
  /** Utile */
  | 'utile';

export type Business_Profile_Enum =
  | 'BUYER'
  | 'SUPPLIER';

export type Gtin_Type_Enum =
  | 'GTIN_8'
  | 'GTIN_12'
  | 'GTIN_13'
  | 'GTIN_14';

export type Marketing_Support_Enum =
  | 'FURNITURE'
  | 'OTHER'
  /** English acronym for 'PLV' */
  | 'POS';

export type Measurement_Unit_Enum =
  | 'CL'
  | 'G'
  | 'KG'
  | 'L'
  | 'ML'
  | 'T'
  /** Used to count units in logistical packages */
  | 'UNIT';

export type Minimum_Order_Value_Type_Enum =
  | 'PACKAGING'
  | 'PRICE'
  | 'WEIGHT';

export type Product_Label_Name_Enum =
  | 'AGRICULTURE_BIOLOGIQUE'
  | 'APPELLATION_ORIGINE_CONTROLEE'
  | 'APPELLATION_ORIGINE_PROTEGEE'
  | 'ECOCERT_ECODETERGENT'
  | 'GOUTEZ_ARDECHE'
  | 'HAUTE_VALEUR_ENVIRONNEMENTALE'
  | 'INDICATION_GEOGRAPHIQUE_PROTEGEE'
  | 'LABEL_ROUGE'
  | 'LE_PORC_FRANCAIS'
  | 'NATURE_ET_PROGRES'
  | 'ORIGINE_FRANCE_GARANTIE'
  | 'PRODUIT_ILE_DE_FRANCE'
  | 'SAVEURS_DE_NORMANDIE'
  | 'VALEURS_PARC_NATUREL_REGIONAL';

export type Return_Policy_Enum =
  | 'FULL'
  | 'PARTIAL';

export type Social_Tag_Type_Enum =
  | 'ENGAGED_STORE'
  | 'GUARANTEED_SALES'
  | 'HIDDEN_GEM'
  | 'HIGHLY_RESPONSIVE'
  | 'HIGH_MARGIN'
  | 'NEW_ARRIVAL'
  | 'POPULAR'
  | 'TREND';

export type Trade_Item_Unit_Descriptor_Enum =
  | 'CASE'
  | 'CRATE'
  | 'DISPLAY'
  | 'HALF_CASE'
  | 'PALLET'
  | 'SACK'
  /** Used when base units are sold individually */
  | 'UNIT';

export type PackagingSheetDataQueryVariables = Exact<{
  sku: number;
  companyId: string;
}>;


export type PackagingSheetDataQuery = { packaging: Array<{ id: string, company_id: string, base_unit_id: string, product_id: string, gtin: string | null, gtin_type: Types.Gtin_Type_Enum | null, sku: number, price: number, trade_item_unit_descriptor: Types.Trade_Item_Unit_Descriptor_Enum, unit_quantity: number | null, content_measurement_unit: Types.Measurement_Unit_Enum | null, net_content: number | null, base_unit: { id: string, sku: number | null, billing_type: Types.Billing_Type_Enum, content_measurement_unit: Types.Measurement_Unit_Enum | null, gtin: string | null, unit_type: Types.Base_Unit_Type_Enum | null, unit_quantity: number | null, unit_net_content: number | null, suggested_retail_price: number | null, availability: Types.Availability_Status_Enum, product_id: string, main_photo: { path: string, domain: string | null } | null, photos: Array<{ photo: { path: string, domain: string | null } }>, social_tags: Array<{ values: { [key: string]: any } | null, type: Types.Social_Tag_Type_Enum, priority: number, level: number }> }, product: { name: string, sku: number, sub_family: string, vat_rate: number | null, labels: Array<{ label: Types.Product_Label_Name_Enum }> } }>, company_by_pk: { legalName: string, is_wholesaler: boolean, id: string, business_profile: Types.Business_Profile_Enum, description: string | null, contactEmail: string, contactPhoneNumber: string, tradeName: string, brand: Types.Brand_Enum | null, provide_marketing: boolean | null, marketing_details: string | null, provide_animation: boolean | null, animation_details: string | null, provide_electrical_appliance: boolean | null, electrical_appliance_details: string | null, provide_return_policy: boolean | null, return_policy: Types.Return_Policy_Enum | null, return_policy_details: string | null, provide_merchandising: boolean | null, merchandising_details: string | null, delivery_description: string | null, delivery_instructions: string | null, delivery_email: string | null, delivery_phone_number: string | null, invoicing_instructions: string | null, invoicing_email: string | null, invoicing_phone_number: string | null, addresses: Array<{ administrativeAreaLevel2: string | null, formattedAddress: string, latitude: number, longitude: number, locality: string | null, postalTown: string | null, countryCode: string, postalCode: string | null }>, social_tags: Array<{ id: string, level: number, priority: number, type: Types.Social_Tag_Type_Enum, values: { [key: string]: any } | null }>, photos: Array<{ photo: { path: string, domain: string | null } }>, marketing_supports: Array<{ support: Types.Marketing_Support_Enum }>, delivery_zones: Array<{ id: string, index: number, minimum_order_value: number, minimum_order_value_type: Types.Minimum_Order_Value_Type_Enum, negotiable_minimum_order_value: boolean, delivery_time: number | null, administrative_areas: Array<{ area: string }> }>, delivery_hours: Array<{ id: string, opening_hour: string, closing_hour: string, week_day: string }>, delivery_address: { id: string, address_1: string, address_2: string | null, postal_code: string, city: string, country: string, name: string } | null, invoicing_address: { id: string, address_1: string, address_2: string | null, postal_code: string, city: string, country: string, name: string } | null } | null, company_product_count_by_sub_family: Array<{ company_id: string, count: number, sub_family: string }> };


export const PackagingSheetDataDocument = /*#__PURE__*/ gql`
    query packagingSheetData($sku: Int!, $companyId: uuid!) {
  packaging(where: {sku: {_eq: $sku}, company_id: {_eq: $companyId}}) {
    ...packagingFragment
  }
  company_by_pk(id: $companyId) {
    ...companyFragment
    ...companyServicesFragment
    legalName
    addresses {
      administrativeAreaLevel2
      formattedAddress
      latitude
      longitude
      locality
      postalTown
      countryCode
      postalCode
    }
    is_wholesaler
    social_tags(where: {base_unit_sku: {_is_null: true}}) {
      ...socialTagsFragment
    }
    ...additionalCompanyInfoFragment
  }
  company_product_count_by_sub_family(args: {company_id: $companyId}) {
    company_id
    count
    sub_family
  }
}
    ${PackagingFragmentFragmentDoc}
${CompanyFragmentFragmentDoc}
${CompanyServicesFragmentFragmentDoc}
${SocialTagsFragmentFragmentDoc}
${AdditionalCompanyInfoFragmentFragmentDoc}`;

/**
 * __usePackagingSheetDataQuery__
 *
 * To run a query within a React component, call `usePackagingSheetDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackagingSheetDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackagingSheetDataQuery({
 *   variables: {
 *      sku: // value for 'sku'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function usePackagingSheetDataQuery(baseOptions: Apollo.QueryHookOptions<PackagingSheetDataQuery, PackagingSheetDataQueryVariables> & ({ variables: PackagingSheetDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackagingSheetDataQuery, PackagingSheetDataQueryVariables>(PackagingSheetDataDocument, options);
      }
export function usePackagingSheetDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackagingSheetDataQuery, PackagingSheetDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackagingSheetDataQuery, PackagingSheetDataQueryVariables>(PackagingSheetDataDocument, options);
        }
// @ts-ignore
export function usePackagingSheetDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PackagingSheetDataQuery, PackagingSheetDataQueryVariables>): Apollo.UseSuspenseQueryResult<PackagingSheetDataQuery, PackagingSheetDataQueryVariables>;
export function usePackagingSheetDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PackagingSheetDataQuery, PackagingSheetDataQueryVariables>): Apollo.UseSuspenseQueryResult<PackagingSheetDataQuery | undefined, PackagingSheetDataQueryVariables>;
export function usePackagingSheetDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PackagingSheetDataQuery, PackagingSheetDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PackagingSheetDataQuery, PackagingSheetDataQueryVariables>(PackagingSheetDataDocument, options);
        }
export type PackagingSheetDataQueryHookResult = ReturnType<typeof usePackagingSheetDataQuery>;
export type PackagingSheetDataLazyQueryHookResult = ReturnType<typeof usePackagingSheetDataLazyQuery>;
export type PackagingSheetDataSuspenseQueryHookResult = ReturnType<typeof usePackagingSheetDataSuspenseQuery>;
export type PackagingSheetDataQueryResult = Apollo.QueryResult<PackagingSheetDataQuery, PackagingSheetDataQueryVariables>;